module.exports = __webpack_public_path__ + "fonts/VetoSansCond-CondLight.af0bb6a7.ttf";